<template>
    <el-card>
        <el-tabs v-model="activeName">
            <el-tab-pane label="云服务概览" name="first">
                <cloud-service-account></cloud-service-account>
            </el-tab-pane>
            <el-tab-pane label="云服务支出明细" name="second">
                <cloud-service-expenditure></cloud-service-expenditure>
            </el-tab-pane>
            <el-tab-pane label="购买云服务明细" name="three">
                <cloud-service-recharge></cloud-service-recharge>
            </el-tab-pane>
        </el-tabs>

    </el-card>
</template>
<script>

import CloudServiceAccount from '@/pages/vipCard/cloudServiceManager/children/CloudServiceAccount'
import CloudServiceExpenditure from '@/pages/vipCard/cloudServiceManager/children/CloudServiceExpenditure'
import CloudServiceRecharge from '@/pages/vipCard/cloudServiceManager/children/CloudServiceRecharge'
export default {
  components: { CloudServiceRecharge, CloudServiceExpenditure, CloudServiceAccount },
  data () {
    return {
      activeName: 'first'
    }
  }
}
</script>
